export default {"src":"/_next/static/media/logo2.ee7f6cf4.svg","height":72,"width":70,"blurWidth":0,"blurHeight":0};